import { defaults } from "../utils/defaults";
import { getParameter, isJSON } from "../utils/common-utils";
import { configs } from "../utils/metadata";

export const getConfig = (key) => {
  const configData = configs();

  const configInfo = getParameter(configData, key);

  return configInfo
    ? configInfo.values.length === 1
      ? configInfo.values[0]
      : configInfo.values
    : defaults[key];
};

const useConfigs = (keys) => {
  const configData = {};
  const configuration = configs();

  keys.forEach((key) => {
    let configInfo = getParameter(configuration, key);

    let data = configInfo
      ? configInfo.values.length === 1
        ? configInfo.values[0]
        : configInfo.values
      : defaults[key];

    if (isJSON(data)) {
      data = JSON.parse(data);
    }
    configData[key] = data;
  });

  return configData;
};

export default useConfigs;